import React from 'react';
import { Pressable } from 'react-native';
import { CheckBox } from '@ui-kitten/components';
import styled from "../../../theming/util/styled";
import DNABox from "../../layout/DNABox/DNABox";
/** APPEARANCE */
export var DNACheckboxAppearanceEnum;
(function (DNACheckboxAppearanceEnum) {
    DNACheckboxAppearanceEnum["default"] = "default";
    DNACheckboxAppearanceEnum["outline"] = "outline";
})(DNACheckboxAppearanceEnum || (DNACheckboxAppearanceEnum = {}));
export const DNACheckboxAppearanceKeys = Object.keys(DNACheckboxAppearanceEnum);
/** STATUS */
export var DNACheckboxStatusEnum;
(function (DNACheckboxStatusEnum) {
    DNACheckboxStatusEnum["primary"] = "primary";
    DNACheckboxStatusEnum["success"] = "success";
    DNACheckboxStatusEnum["warning"] = "warning";
    DNACheckboxStatusEnum["danger"] = "danger";
})(DNACheckboxStatusEnum || (DNACheckboxStatusEnum = {}));
export const DNACheckboxStatusKeys = Object.keys(DNACheckboxStatusEnum);
/** CONTEXT */
export var DNACheckboxContextEnum;
(function (DNACheckboxContextEnum) {
    DNACheckboxContextEnum["altBg"] = "altBg";
})(DNACheckboxContextEnum || (DNACheckboxContextEnum = {}));
export const DNACheckboxContextKeys = Object.keys(DNACheckboxContextEnum);
const parseComponentStyle = (source) => {
    const { containerBorderRadius, containerBorderWidth, containerBorderColor, containerPaddingLeft, containerPaddingRight, containerPaddingVertical, } = source;
    return {
        containerStyle: {
            borderRadius: containerBorderRadius,
            borderWidth: containerBorderWidth,
            borderColor: containerBorderColor,
            paddingLeft: containerPaddingLeft,
            paddingRight: containerPaddingRight,
            paddingVertical: containerPaddingVertical,
        },
    };
};
export const DNACheckbox = (props) => {
    const { eva, ...rest } = props;
    const { containerStyle } = parseComponentStyle(eva.style);
    return (<CheckBox style={containerStyle} {...rest}/>);
};
const PWACheckBox = ({ width = 28, height = 28, onChange, checked, children, testID }) => {
    return (<Pressable onPress={onChange} testID={testID}>
      <DNABox testID="pwa-checkbox" spacing="sm" alignY="center">
        {checked
            ? <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* eslint-disable-next-line max-len */}
            <path d="M15 25.5L7.5 18L9.615 15.87L15 21.255L26.385 9.87L28.5 12L15 25.5ZM28.5 4.5H7.5C5.835 4.5 4.5 5.835 4.5 7.5V28.5C4.5 29.2956 4.81607 30.0587 5.37868 30.6213C5.94129 31.1839 6.70435 31.5 7.5 31.5H28.5C29.2956 31.5 30.0587 31.1839 30.6213 30.6213C31.1839 30.0587 31.5 29.2956 31.5 28.5V7.5C31.5 5.835 30.15 4.5 28.5 4.5Z" fill="#44A2DA"/>
          </svg>
            : <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* eslint-disable-next-line max-len */}
            <path d="M28.5 4.5H7.5C5.835 4.5 4.5 5.835 4.5 7.5V28.5C4.5 29.2956 4.81607 30.0587 5.37868 30.6213C5.94129 31.1839 6.70435 31.5 7.5 31.5H28.5C29.2956 31.5 30.0587 31.1839 30.6213 30.6213C31.1839 30.0587 31.5 29.2956 31.5 28.5V7.5C31.5 5.835 30.15 4.5 28.5 4.5ZM28.5 7.5V28.5H7.5V7.5H28.5Z" fill="#1D1D1D"/>
          </svg>}
        {children}
      </DNABox>
    </Pressable>);
};
DNACheckbox.PWA = PWACheckBox;
// We reuse the CheckBox style
export default styled('CheckBox')(DNACheckbox);
//# sourceMappingURL=DNACheckbox.js.map